import Vue from 'vue'
import Router from 'vue-router'
import App from '../src/App.vue';
import home from './views/home/home.vue'
import reg from './views/reg/reg.vue'
import charge from './components/charge/charge.vue'
import guardianship from './views/guardianship/guardianship.vue'
import dispute from './views/dispute/dispute.vue'
import addicted from './views/addicted/addicted.vue'
import toGame from './page/game.vue'
import parentcustody from './views/parentcustody/parentcustody.vue'
import lostinself from './views/lostinself/lostinself.vue'
import aboutus from './views/aboutus/aboutus.vue'


/*游戏下载*/
const gamecenter = r => require.ensure([], () => r(require('./components/gamecenter/gamecenter')), 'gamecenter')
const download_xl = r => require.ensure([], () => r(require('./components/gamedownload/download_xl')), 'download_xl')
const download_sc = r => require.ensure([], () => r(require('./components/gamedownload/download_sc')), 'download_sc')
const download_gd = r => require.ensure([], () => r(require('./components/gamedownload/download_gd')), 'download_gd')
const download_sx = r => require.ensure([], () => r(require('./components/gamedownload/download_sx')), 'download_sx')
const download_gz = r => require.ensure([], () => r(require('./components/gamedownload/download_gz')), 'download_gz')
const download_gx = r => require.ensure([], () => r(require('./components/gamedownload/download_gx')), 'download_gx')
const download_gs = r => require.ensure([], () => r(require('./components/gamedownload/download_gs')), 'download_gs')
const download_yn = r => require.ensure([], () => r(require('./components/gamedownload/download_yn')), 'download_yn')
const download_fj = r => require.ensure([], () => r(require('./components/gamedownload/download_fj')), 'download_fj')
const download_nx = r => require.ensure([], () => r(require('./components/gamedownload/download_nx')), 'download_nx')
const download_anhui = r => require.ensure([], () => r(require('./components/gamedownload/download_anhui')), 'download_anhui')
const download_nm = r => require.ensure([], () => r(require('./components/gamedownload/download_nm')), 'download_nm')
// const download_ddz = r => require.ensure([], () => r(require('./components/gamedownload/download_ddz')), 'download_ddz')
// const download_pdk = r => require.ensure([], () => r(require('./components/gamedownload/download_pdk')), 'download_pdk')
// const download_phz = r => require.ensure([], () => r(require('./components/gamedownload/download_phz')), 'download_phz')
const download_hn = r => require.ensure([], () => r(require('./components/gamedownload/download_hn')), 'download_hn')
import DownloadHeNan from './components/gamedownload/DownloadHeNan.vue'

Vue.use(Router)

export default new Router({
  base: process.env.BASE_URL,
  mode: 'history',
  routes: [
    { path: '/', redirect: { name: 'home' } },
    {
      path: '/home',
      name: 'home',
      component: home
    },
    // TODO:
    // {
    //   path: '/charge',
    //   name: 'charge',
    //   component: charge
    // },
    {
      path: '/reg',
      name: 'reg',
      component: reg
    },
    {
      path: '/guardianship',
      name: 'guardianship',
      component: guardianship
    },
    {
      path: '/dispute',
      name: 'dispute',
      component: dispute
    },
    {
      path: '/addicted',
      name: 'addicted',
      component: addicted
    },
    {
      path: '/toGame',
      name: 'toGame',
      component: toGame
    },
    {
      path:'/parentcustody',
      name:'parentcustody',
      component:parentcustody
    },
    {
      path:'/lostinself',
      name:'lostinself',
      component:lostinself
    },
    {
      path:'/aboutus',
        name:'aboutus',
      component:aboutus
    },
    //游戏下载详情(闲来麻将)
    {
      path: '/download_xl',
      name: 'download_xl',
      component: download_xl
    },
    //游戏下载详情(四川麻将)
    {
      path: '/download_sc',
      name: 'download_sc',
      component: download_sc
    },
    //游戏下载详情(广东麻将)
    {
      path: '/download_gd',
      name: 'download_gd',
      component: download_gd
    },
    //游戏下载详情(陕西麻将)
    {
      path: '/download_sx',
      name: 'download_sx',
      component: download_sx
    },
    //游戏下载详情(贵州麻将)
    {
      path: '/download_gz',
      name: 'download_gz',
      component: download_gz
    },
    //游戏下载详情(广西麻将)
    {
      path: '/download_gx',
      name: 'download_gx',
      component: download_gx
    },
    //游戏下载详情(甘肃麻将)
    {
      path: '/download_gs',
      name: 'download_gs',
      component: download_gs
    },
    //游戏下载详情(云南麻将)
    {
      path: '/download_yn',
      name: 'download_yn',
      component: download_yn
    },
    //游戏下载详情(福建麻将)
    {
      path: '/download_fj',
      name: 'download_fj',
      component: download_fj
    },
    //游戏下载详情(宁夏麻将)
    {
      path: '/download_nx',
      name: 'download_nx',
      component: download_nx
    },

    //游戏下载详情(安徽麻将)
    {
      path: '/download_anhui',
      name: 'download_anhui',
      component: download_anhui
    },

    //游戏下载详情(内蒙麻将)
    {
      path: '/download_nm',
      name: 'download_nm',
      component: download_nm
    },
    //游戏下载详情(海南麻将)
    {
      path: '/download_hn',
      name: 'download_hn',
      component: download_hn
    },
    //游戏下载详情  下载data 参数下载所有游戏
    {
      path: '/download/:province',
      name: 'download_henan',
      component: DownloadHeNan
    },

    //游戏下载详情(斗地主)
    // {
    //   path: '/download_ddz',
    //   name: 'download_ddz',
    //   component: download_ddz
    // },
    //游戏下载详情(跑得快)
    // {
    //   path: '/download_pdk',
    //   name: 'download_pdk',
    //   component: download_pdk
    // },
    //游戏下载详情(跑胡子)
    // {
    //   path: '/download_phz',
    //   name: 'download_phz',
    //   component: download_phz
    // },
    //游戏中心
    {
      path: '/gamecenter',
      name: 'gamecenter',
      component: gamecenter
    },
  ]
})
